"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorVar = exports.SMAR_PREFIX = exports.COLOR_ICONS_PREFIX = void 0;
const COLOR_ICONS_PREFIX = "--sds--ursa-icons--";
exports.COLOR_ICONS_PREFIX = COLOR_ICONS_PREFIX;
const SMAR_PREFIX = "--smar--com--color--";
exports.SMAR_PREFIX = SMAR_PREFIX;
const getColorVar = function (name, fallback) {
  let isBackground = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return `var(${COLOR_ICONS_PREFIX}${isBackground ? "background-color--" : ""}${name}, ${fallback})`;
};
exports.getColorVar = getColorVar;
//# sourceMappingURL=color-icon-helpers.js.map